import { Property } from 'csstype';
import { FC } from 'react';
import styled, { DefaultTheme, IntrinsicElementsKeys, StyledComponent } from 'styled-components';

import { BreakpointTypes } from '@folx-types/theme';

import theme from '@theme/FolxTheme';

interface IVisible {
	breakpoint: BreakpointTypes;
	defaultVisible?: boolean;
	display?: Property.Display;
}

const visible = <U>(
	component: StyledComponent<IntrinsicElementsKeys | FC<U>, DefaultTheme> | IntrinsicElementsKeys
) =>
	styled<StyledComponent<IntrinsicElementsKeys | FC<U>, DefaultTheme> | IntrinsicElementsKeys>(
		component
	)<IVisible>`
		display: ${({ display = 'block', defaultVisible = false }) =>
			defaultVisible ? display : 'none'};

		@media ${({ breakpoint }) => theme.responsive.breakpoints[breakpoint]} {
			display: ${({ display = 'block', defaultVisible = false }) =>
				defaultVisible ? 'none' : display};
		}
	`;

export default visible;
